import { render } from "./DeleteSkillModal.vue?vue&type=template&id=047916f1&ts=true"
import script from "./DeleteSkillModal.vue?vue&type=script&lang=ts"
export * from "./DeleteSkillModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__